import { z } from 'zod';
import { BillSchema } from './bill.js';
import { InvoiceSchema } from './invoice.js';
export const ServiceHookEventTypeSchema = z.enum(['invoice', 'bill', 'error']);
export const ServiceHookEventTypeEnum = ServiceHookEventTypeSchema.enum;
export const ServiceHookEventActionSchema = z.enum(['create', 'download']);
export const ServiceHookEventActionEnum = ServiceHookEventActionSchema.enum;
export const ServiceHookEventSchema = z.object({
    action: ServiceHookEventActionSchema,
    type: ServiceHookEventTypeSchema,
    entity: z.unknown(),
});
export const ErrorResponseSchema = z.object({
    error: z.string(),
    type: z.literal(ServiceHookEventTypeEnum.error),
});
// #region invoicing
export const ServiceHookInvoiceEventSchema = ServiceHookEventSchema.merge(z.object({
    type: z.literal(ServiceHookEventTypeEnum.invoice),
    entity: InvoiceSchema.partial().required({
        entityId: true,
    }),
}));
export const isServiceHookInvoiceEvent = (event) => ServiceHookInvoiceEventSchema.safeParse(event).success;
export const DownloadInvoiceEventSchema = ServiceHookInvoiceEventSchema.merge(z.object({
    action: z.literal(ServiceHookEventActionEnum.download),
    entity: InvoiceSchema.pick({ entityId: true, id: true }),
}));
export const isDownloadInvoiceEvent = (entity) => DownloadInvoiceEventSchema.safeParse(entity).success;
export const DownloadInvoiceEventResponseSchema = ServiceHookInvoiceEventSchema.merge(z.object({
    action: z.literal(ServiceHookEventActionEnum.download),
    entity: InvoiceSchema.pick({ entityId: true }).merge(z.object({ pdf: z.string() })),
}));
export const isDownloadInvoiceEventResponse = (entity) => DownloadInvoiceEventResponseSchema.safeParse(entity).success;
export const CreateInvoiceEventSchema = ServiceHookInvoiceEventSchema.merge(z.object({
    action: z.literal(ServiceHookEventActionEnum.create),
    entity: InvoiceSchema.partial().required({
        entityId: true,
        customer: true,
    }),
}));
export const isCreateInvoiceEvent = (entity) => CreateInvoiceEventSchema.safeParse(entity).success;
export const CreateInvoiceEventResponseSchema = ServiceHookInvoiceEventSchema.merge(z.object({
    action: z.literal(ServiceHookEventActionEnum.create),
    entity: InvoiceSchema,
}));
export const isCreateInvoiceEventResponse = (event) => CreateInvoiceEventResponseSchema.safeParse(event).success;
// #endregion
// region billing
export const ServiceHookBillEventSchema = z.object({
    action: z.literal(ServiceHookEventActionEnum.create),
    type: z.literal(ServiceHookEventTypeEnum.bill),
    entity: BillSchema.partial().required({
        entityId: true,
    }),
});
export const isServiceHookBillEvent = (entity) => ServiceHookBillEventSchema.safeParse(entity).success;
export const CreateBillEventSchema = ServiceHookBillEventSchema.merge(z.object({
    action: z.literal(ServiceHookEventActionEnum.create),
}));
export const isCreateBillEvent = (entity) => CreateBillEventSchema.safeParse(entity).success;
export const CreateBillEventResponseSchema = ServiceHookBillEventSchema.merge(z.object({
    action: z.literal(ServiceHookEventActionEnum.create),
    entity: BillSchema,
}));
export const isCreateBillEventResponse = (event) => CreateBillEventResponseSchema.safeParse(event).success;
// #endregion
export const ServiceHookEventsSchema = z.union([
    CreateInvoiceEventSchema,
    DownloadInvoiceEventSchema,
    CreateBillEventSchema,
]);
export const ServiceHookEventResponseSchema = z.union([
    CreateInvoiceEventResponseSchema,
    DownloadInvoiceEventResponseSchema,
    CreateBillEventResponseSchema,
]);
